// @flow

// Types
import type {
  Fertilizer,
} from 'fc-model-fertilizers/types'

// Libs
import { createSelector } from 'reselect'
import _forEach from 'lodash/forEach'
import _split from 'lodash/split'

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { TREE, BRANCH, PROP_HEFTY_PRIMARY_NUTRIENTS } from 'fc-model-fertilizers'

export default createSelector(
  [traverse([TREE, BRANCH])],
  function (fertilizers: { [number]: Fertilizer }): Array<SoilJob> {
    const fertilizersByNutrient = {}
    _forEach(fertilizers, (fertilizer: Fertilizer) => {
      const nutrients = _split(fertilizer[PROP_HEFTY_PRIMARY_NUTRIENTS], ',')
      _forEach(nutrients, (nutrient: string) => {
        if (!fertilizersByNutrient[nutrient]) {
          fertilizersByNutrient[nutrient] = []
        }
        fertilizersByNutrient[nutrient].push(fertilizer)
      })
    })
    return fertilizersByNutrient
  }
)
